import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TaskService } from '../../services/task.service';
import { AuthService } from '../../core/auth-service';
import { NotificationService } from '../../services/notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PagerService } from '../../pager/services/pager.service';
import { TaskSortTypes } from '../enums/task-sort-types';
import { catchError, EMPTY, Subject, take, takeUntil, tap } from 'rxjs';
import { UserTask } from '../models/user-task.model';
import { BuyerService } from '../../services/buyer.service';
import { Site } from '../../diary/models/site.model';
import { AppointmentDetailsComponent } from '../../appointment-details/appointment-details.component';
import { NavigationHistoryService } from '../../core/navigation-history.service';

@Component({
  selector: 'app-task-list-branch',
  templateUrl: './task-list-branch.component.html',
  styleUrl: './task-list-branch.component.scss'
})
export class TaskListBranchComponent implements OnInit, OnDestroy {
  constructor(
    public taskService: TaskService,
    private authService: AuthService,
    private notifications: NotificationService,
    private modalService: NgbModal,
    private pagerService: PagerService,
    private buyerService: BuyerService,
    private navigationHistory: NavigationHistoryService
  ) { }
  @Input() initialTaskId: number;
  loading: boolean;
  username: string;
  sortOrder: string;
  public sortTypes = Object.values(TaskSortTypes);
  isEditing: boolean;
  sortOpened: boolean;
  destroy$ = new Subject();
  pagedTasks: Array<UserTask>;
  pageCount: number;
  currentPage = 1;
  filteredTasks: Array<UserTask>;
  pageSize = 6;
  branchTasks: UserTask[];
  current_site: Site;
  tableHasData: boolean;

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.loading = true;
    this.username = this.authService.getUser()?.username.split('@')[0].toLowerCase();
    this.sortOrder = TaskSortTypes.TaskType;
    this.current_site = this.buyerService.getCurrentSiteFromStorage();
    if (this.current_site) {
      this.retrieveTasks(this.current_site.siteId);
    }
  }

  retrieveTasks(siteId: number) {
    this.taskService.getBranchTasks$(siteId).pipe(
      tap(result => {
        this.branchTasks = result;
        this.filterTasks();
        this.showActionTask();
        this.loading = false;
      }),
      catchError(err => {
        this.notifications.dangerToast(`Failed to go retrieve task list`, err);
        this.loading = false;
        return EMPTY;
      }),
      take(1)
    ).subscribe();
    this.pagerService.getPageNumber().pipe(
      takeUntil(this.destroy$),
      catchError(() => {
        return EMPTY;
      })
    )
      .subscribe((result) => {
        if (this.filteredTasks) {
          this.onPageChange(result);
        }
      });
  }

 showActionTask() {
    let taskToAction = 0;
    const previousUrl = this.navigationHistory.getPreviousUrl();
    if (this.loading && this.initialTaskId) {
      taskToAction = this.initialTaskId;
    } else if (previousUrl?.split('/').includes('postPurchase') && this.navigationHistory.getId()) {
      taskToAction = this.navigationHistory.getId();
    }
    if (taskToAction > 0) {
      let done = false;
      while (!done) {
        const task = this.pagedTasks.find(x => x.taskId === taskToAction);
        if (task) {
          done = true;
          this.actionTask(task);
        } else {
          if (this.currentPage >= this.pageCount) {
            this.currentPage = 1;
            done = true;
          } else {
            this.currentPage++;
          }
          this.pageTasks();
        }
      }
    }
  }

  filterTasks() {
    this.filteredTasks = this.buyerService.sortTasks(this.sortOrder, this.branchTasks);
    const taskCount = this.filteredTasks.length;
    this.pageCount = Math.ceil(taskCount / this.pageSize);
    if (this.currentPage > this.pageCount) {
      this.currentPage = 1;
    }
    this.pageTasks();
  }

  actionTask(task: UserTask) {
    const modalRef = this.modalService.open(AppointmentDetailsComponent, {
      keyboard: false,
      backdrop: 'static',
      centered: true,
      size: 'xl'
    });

    modalRef.componentInstance.appointmentId = task.appointmentId;
    modalRef.componentInstance.taskId = task.taskId;
    modalRef.componentInstance.attempts = task.attempts;
    modalRef.componentInstance.taskTitle = this.taskService.getTaskTitle(task);
    modalRef.componentInstance.taskType = task.taskType;
    modalRef.componentInstance.taskOutcomeTypeId = task.taskOutcomeTypeId;
    modalRef.result.then(() => {
      this.filteredTasks = [];
      this.pagedTasks = [];
      this.retrieveTasks(this.current_site.siteId);
    }, () => { });
  }

  pageTasks() {
    if (this.pageCount === 1) {
      this.pagedTasks = this.filteredTasks;
    } else {
      const start = (this.currentPage * this.pageSize) - this.pageSize;
      if (this.currentPage === this.pageCount) {
        this.pagedTasks = this.filteredTasks.slice(start);
      } else {
        const end = this.currentPage * this.pageSize;
        this.pagedTasks = this.filteredTasks.slice(start, end);
      }
    }

    if (this.pagedTasks.length > 0 || this.pageCount > 1) {
      this.tableHasData = true;
    } else {
      this.tableHasData = false;
    }
  }

  onSortChange($event) {
    this.sortOrder = $event;
    this.buyerService.sortTasks(this.sortOrder, this.filteredTasks);
    this.pageTasks();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.pageTasks();
  }

  toggleSort() {
    this.sortOpened = !this.sortOpened;
  }


}
